export const simpleLog: (...msgs: Array<string | Record<string, any> | undefined>) => void = (
  ...msgs
) =>
  // eslint-disable-next-line no-console
  console.log(...msgs.filter((item) => item !== undefined));
